import React from "react";
import dayjs from "dayjs";
import { Row, Col, Typography, Card } from "antd";
import { SelectInput, InputField, TextareaField, AntdButton, DatePickerField } from "../../../blueplanitUtils/InputField";
import { USER_ISSUES, ISSUE_STATUS, LEAD_INFORMATION, PRIORITY } from "../../../Dropdownmanager";
import { getOptionsByPath } from "../../../utilsdata";
import { getEmployeesListThunk } from "../../../Slices/Thunk/getemployeelist";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
 
const EditIssueForm = ({
    editingIssue,
    setEditingIssue,
    assignToUsers,
    NestedDatabucket,
    handleUpdate,
    onCancel,
}) => {
 
    const formatDateTime = (timestamp) => {
        return dayjs(Number(timestamp)).format("DD-MM-YYYY hh:mm A");
    };
 
   
    const dispatch = useDispatch();
 
    // const { list: employees, loading: empLoading } = useSelector(
    //     (state) => state.employees
    // );
 
     const employees = useSelector(
      (state) => state.employee.AllEmployees || []
    );
   
 
    const employeesOptions =
    employees.map((emp) => ({
      label: `${emp.firstname} ${emp.lastname}`,
      value: `${emp.firstname} ${emp.lastname}`,
    })) || [];
 
    // useEffect(() => {
    //     dispatch(getEmployeesListThunk());
    // }, [dispatch]);
 
    return (
        <div className="page-wrapper">
            <form onSubmit={handleUpdate}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: -50,
                        marginBottom: 20,
                        paddingRight: 10,
                        paddingLeft: 20,
                        marginRight: 10,
                    }}
                >
                    <Typography.Title level={5} style={{ marginBottom: -40, marginLeft: 20, flex: 1, textAlign: 'left', fontWeight: "bold" }}>Edit Task</Typography.Title>
                    <Row gutter={24} style={{ marginTop: "30px" }}>
                        <Col span={24} style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                            <AntdButton
                                onClick={handleUpdate}
                                style={{
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    marginRight: "10px",
                                }}
                                label="Update"
                            />
                            <AntdButton
                                onClick={onCancel}
                                type="default"
                                style={{
                                    backgroundColor: '#6c757d',
                                    color: '#fff',
                                    padding: "8px 16px",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                                label="Close"
                            />
                        </Col>
                    </Row>
                </div>
                <Card
                    style={{
                        marginLeft: 20,
                        marginRight: 20,
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "8px",
                    }}
                >
                    <Row gutter={20}>
                        <Col span={4}>
                            <InputField
                                label="Task ID"
                                type="text"
                                name="TaskID"
                                value={editingIssue?.TaskID || ""}
                                onChange={(e) => setEditingIssue(prev => ({ ...prev, TaskID: e.target.value }))}
                                disabled
                            />
                        </Col>
                        <Col span={4}>
                            <InputField
                                label="Tab Name"
                                type="text"
                                name="Tabname"
                                value={editingIssue?.Tabname || ""}
                                onChange={(e) => setEditingIssue(prev => ({ ...prev, Tabname: e.target.value }))}
                                disabled={editingIssue?.Status === "Completed"}   // ✅ ADD THIS
                            />
                        </Col>
                        <Col span={6}>
                            <TextareaField
                                label={<>Task Title <span style={{ color: "red" }}>*</span></>}
                                name="TaskTitle"
                                value={editingIssue?.TaskTitle}
                                onChange={(e) => setEditingIssue(prev => ({ ...prev, TaskTitle: e.target.value }))}
                                rows="1"
                                placeholder="Enter Task Title"
                                disabled={editingIssue?.Status === "Completed"}   // ✅ ADD THIS
                            />
                        </Col>
                        <Col span={4}>
                            <InputField
                                label="Created Date"
                                type="text"
                                name="DateAndTime"
                                value={
                                    editingIssue?.DateAndTime
                                        ? formatDateTime(editingIssue.DateAndTime)
                                        : ""
                                }
                                style={{
                                    fontWeight: "bold",
                                    color: "#000",
                                }}
                                onChange={(e) => setEditingIssue(prev => ({ ...prev, DateAndTime: e.target.value }))}
                                disabled
                            />
                        </Col>
                        <Col span={4}>
                            <InputField
                                label="Updated Date"
                                value={
                                    editingIssue?.UpdatedDate
                                        ? dayjs(Number(editingIssue.UpdatedDate)).format("DD/MM/YYYY hh:mm A")
                                        : "—"
                                }
                                disabled
                                style={{ fontWeight: "bold", color: "#000" }}
                            />
                        </Col>
 
 
                        <Col span={4}>
                            <SelectInput
                                label="Created By"
                                options={employeesOptions}
                                 filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
    }
                                value={editingIssue?.CreatedBy || undefined}
                                required
                                disabled={editingIssue?.Status === "Completed"}  
                                onChange={(value) =>
                                    setEditingIssue({ ...editingIssue, CreatedBy: value })
                                }
                                style={{ width: "100%" }}
                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Guided By"
                               options={employeesOptions}
                                filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
    }
                                disabled={editingIssue?.Status === "Completed"}  
                                value={editingIssue?.GuidedBy || ""}
                                onChange={(value) =>
                                    setEditingIssue({ ...editingIssue, GuidedBy: value })
                                }
                                style={{ width: "100%" }}
                            />
 
                        </Col>
                        <Col span={6}>
                            <SelectInput
                                label="Assigned To"
                               options={employeesOptions}
                                filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
    }
                                required
                                value={editingIssue?.Assignedto || ""}
                                mode="multiple"
                                onChange={(value) =>
                                    setEditingIssue({ ...editingIssue, Assignedto: value })
                                }
                                style={{ width: "100%" }}
                                disabled={editingIssue?.Status === "Completed"}  
                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Priority"
                                value={editingIssue?.Priority || "Low"}
                                required
                                onChange={(value) =>
                                    setEditingIssue({ ...editingIssue, Priority: value })
                                }
                                className="form-control"
                                style={{ width: "100%" }}
                                placeholder="Select Priority"
                                dropdownStyle={{ zIndex: 10001 }}
                                options={getOptionsByPath(
                                    NestedDatabucket,
                                    [LEAD_INFORMATION, PRIORITY]
                                )}
                                disabled={editingIssue?.Status === "Completed"}  
                            />
                        </Col>
 
                        <Col span={4}>
                            <DatePickerField
                                label="Dead line"
                                value={editingIssue?.Deadline ? dayjs(editingIssue.Deadline) : null}
                                onChange={(value) =>
                                    setEditingIssue({ ...editingIssue, Deadline: value })
                                }
                                format="DD/MM/YYYY"
                                allowClear={false}
                                disabledDate={(current) =>
                                    current && current < dayjs().startOf("day")
                                }
                                style={{ width: "100%" }}
                                disabled={editingIssue?.Status === "Completed"}  
                                placeholder="Select Deadline"
                            />
                        </Col>
 
                        <Col span={8}>
                            <TextareaField
                                label={<>Task Description<span style={{ color: "red" }}>*</span></>}
                                name="issuedescription"
                                disabled={editingIssue?.Status === "Completed"}  
                                value={editingIssue?.issuedescription}
                                onChange={(e) => setEditingIssue(prev => ({ ...prev, issuedescription: e.target.value }))}
                                rows="3"
                            />
                        </Col>
                        <Col span={10}>
                            <TextareaField
                                label="Guide Notes"
                                name="Instructions"
                                disabled={editingIssue?.Status === "Completed"}  
                                value={editingIssue?.Instructions}
                                onChange={(e) => setEditingIssue(prev => ({ ...prev, Instructions: e.target.value }))}
                                rows="3"
                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Task Status"
                                value={editingIssue?.Status || ""}
                                onChange={(value) =>
                                    setEditingIssue({ ...editingIssue, Status: value })
                                }
                                className="form-control"
                                disabled
                                style={{ width: "100%" }}
                                dropdownStyle={{ zIndex: 10001 }}
                                options={getOptionsByPath(NestedDatabucket, [USER_ISSUES, ISSUE_STATUS])}
 
                            />
                        </Col>
 
                        {/* Quality Score */}
                        {editingIssue?.Status === "Completed" && (
                            <>
                                <Col span={4}>
                                    <InputField
                                        label="Quality Score"
                                        type="number"
                                        value={editingIssue?.QualityScore || ""}
                                        required
                                        onChange={(e) =>
                                            setEditingIssue((prev) => ({ ...prev, QualityScore: e.target.value }))
                                        }
                                        style={{ width: "100%" }}
                                    />
                                </Col>
 
                                <Col span={8}>
                                    <TextareaField
                                        label={<>Final Remarks<span style={{ color: "red" }}>*</span></>}
                                        value={editingIssue?.FinalRemarks || ""}
                                        onChange={(e) =>
                                            setEditingIssue((prev) => ({ ...prev, FinalRemarks: e.target.value }))
                                        }
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                            </>
                        )}
 
                    </Row>
                </Card>
            </form>
        </div>
    );
};
 
export default EditIssueForm;